import type { ReactNode } from 'react';
import { WalletCta } from '../WalletCta';

export interface FunnelBannerProps {
  /** The two-line ask. Callers paint their own `.muted-word` if they want one. */
  heading: ReactNode;
  /** The single action under it. Defaults to the wallet call to action. */
  action?: ReactNode;
}

/**
 * The page's last ask, on the blue funnel.
 *
 * Not a `Band`: the two vertical hairlines the rest of the page hangs from stop
 * at the section above it, so the banner is the one panel that stands on the
 * page rather than inside the column. That is what makes it read as the end.
 *
 * One action, and no second line of reassurance under it. The hero's pill
 * already carries the offer and the card, and repeating either here would be a
 * third place for the same number to go stale.
 */
export const FunnelBanner = ({ heading, action }: FunnelBannerProps) => (
  <div className="page-wrap pb-14 sm:pb-16 xl:pb-24">
    <div className="banner-blue px-6 py-16 text-center sm:py-24 xl:py-32">
      <h2 className="display-2 text-text">{heading}</h2>
      <div className="mt-8 flex justify-center">{action ?? <WalletCta className="px-5" />}</div>
    </div>
  </div>
);
